import { useTranslation } from "@i18n";
import { useState } from "react";
import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { ImCross } from "react-icons/im";
import { saveFileCalibrationToEstimate } from "@Actions/estimation";
import { useParams } from "react-router-dom";
import { CubeGlobal } from "@Features/viewer-core";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

function CalibrationModal({ viewerImpl, handleCalibrationModal }: any) {
  const { t } = useTranslation();
  const [selectedScale, setSelectedScale] = useState<any>(null);
  // External entry point: the `:fileId` route param is a raw string, so it is typed once here, on
  // the hook itself (the backend route schema validates it).
  const params = useParams<{ fileId: ObjectIdString }>();
  const [calibrationType, setCalibrationType] = useState("standard");
  const calibrationData = [
    { id: "1:1", scale: "1:1" },
    { id: "1:2", scale: "1:2" },
    { id: "1:5", scale: "1:5" },
    { id: "1:10", scale: "1:10" },
    { id: "1:20", scale: "1:20" },
    { id: "1:25", scale: "1:25" },
    { id: "1:30", scale: "1:30" },
  ];

  const activateOperator = function (operatorId: any, opIndex = 1) {
    viewerImpl.activateOperator(operatorId, opIndex);
  };

  const standardCalibrationSelected = () => {
    if (!selectedScale) return;
    const valueSelected = selectedScale.id.split(":")[1];
    CubeGlobal.calibrationScale = valueSelected;
    saveFileCalibrationToEstimate({
      fileVersionId: params.fileId,
      scale: parseFloat(valueSelected),
    });
    handleCalibrationModal(false);
  };
  return (
    <div className="fixed top-1/4 start-[40%] z-[4] h-fit w-[22rem] overflow-y-auto bg-white shadow-[0.25rem_0.5rem_0.625rem_rgba(0,0,0,0.12)]">
      <div className="flex items-center justify-between px-5 pb-1 pt-4">
        <h3 className="text-lg font-bold">{t("Scale")}</h3>
        <ImCross size={12} onClick={() => handleCalibrationModal(false)} className="cursor-pointer" />
      </div>
      <div>
        <div className="flex flex-row justify-evenly bg-[var(--background-scrim)]">
          <div
            onClick={() => setCalibrationType("standard")}
            className={`${calibrationType === "standard" ? "border-b-1 border-[#7bd2fc]" : ""} cursor-pointer py-2.5`}
          >
            <p>{t("Standard Scale")}</p>
          </div>
          <div
            onClick={() => setCalibrationType("custom")}
            className={`${calibrationType === "custom" ? "border-b-1 border-[#7bd2fc]" : ""} cursor-pointer py-2.5`}
          >
            <p>{t("Calibrate Scale")}</p>
          </div>
        </div>
        {calibrationType === "standard" && (
          <div className="p-5">
            <AutoComplete
              options={calibrationData}
              valueField="id"
              getOptionLabel={(option: any) => option?.scale || ""}
              value={selectedScale}
              onChange={(_event: any, newValue: any) => setSelectedScale(newValue)}
              renderInput={(params: any) => <TextFieldComponent {...params} placeholder={t("Select a scale")} />}
            />
            <ButtonComponent
              className="mt-5"
              buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              onClick={standardCalibrationSelected}
            >
              {t("Ok")}
            </ButtonComponent>
          </div>
        )}
        {calibrationType === "custom" && (
          <div className="p-5">
            <p>{t("Select two points to calibrate measuring tool.")}</p>
            <ButtonComponent
              className="mt-5"
              buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              onClick={() => {
                activateOperator(CubeGlobal.OperatorId.QTakeOffCalibrationOperator);
                handleCalibrationModal(false);
              }}
            >
              {t("Ok")}
            </ButtonComponent>
          </div>
        )}
      </div>
    </div>
  );
}

export default CalibrationModal;
